import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { Box } from "@chakra-ui/react";
import { MenuContent, MenuRoot } from "components/ui/menu";
import { useOutsideClick } from "hooks/useOutsideClick";
import { POPUP_WRAPPER_ZINDEX } from "utils/constants";

import { IDropDownPopUpProp, IDropDownPopUpRef } from "./types";

export const DropDownPopUp = forwardRef<IDropDownPopUpRef, IDropDownPopUpProp>(
  (props, ref) => {
    const {
      position,
      children,
      dropDownBtnRef,
      dropDownWidth,
      allowOutSideClick,
      dropDownPopUpMenuContentCss,
      dropDownPopUpMenuContentClassName,
      dropDownPopUpTopPosition,
      dropDownOverlayClassName,
    } = props;
    const [open, setOpen] = useState(false);

    const handleToggle = () => setOpen(!open);
    const handleClose = () => setOpen(false);

    useImperativeHandle(ref, () => ({
      isDropDownOpen: open,
      handleToggleDropdown: handleToggle,
    }));

    const menuRef = useRef<HTMLDivElement | null>(null);
    useOutsideClick(
      menuRef,
      () => {
        if (!allowOutSideClick) return;
        handleClose();
      },
      dropDownBtnRef
    );

    return (
      <>
        {open && (
          <Box
            className={`fixed top-0 left-0 w-screen h-screen z-[1100] ${dropDownOverlayClassName || ""}`}
            onClick={allowOutSideClick ? handleClose : undefined}
          />
        )}
        <MenuRoot
          open={open}
          anchorPoint={{
            x: position.left,
            y: dropDownPopUpTopPosition || position.top,
          }}
        >
          <MenuContent
            css={{
              ...dropDownPopUpMenuContentCss,
              zIndex: POPUP_WRAPPER_ZINDEX,
            }}
            className={dropDownPopUpMenuContentClassName}
            width={dropDownWidth}
            ref={menuRef}
          >
            {children}
          </MenuContent>
        </MenuRoot>
      </>
    );
  }
);
